import { useMemo } from 'react';
import { parseTicker } from '@/lib/kalshiTicker/parse';
import { resolvedGamePair } from '@/lib/kalshiTicker/describeMarket';
import { composeHydraGameKey } from '@/services/analyticsGameKey';

/** Resolve only held tickers, not the market universe. Feed revision is needed
 * because identity can arrive or disappear without the position changing. */
export function usePositionGameKeys(
  positions: ReadonlyArray<{ ticker: string }>,
  marketVersion: number,
): ReadonlySet<string> {
  return useMemo(() => {
    void marketVersion;
    const keys = new Set<string>();
    for (const position of positions) {
      const parsed = parseTicker(position.ticker);
      const pair = resolvedGamePair(position.ticker, parsed);
      if (!pair || !parsed.date) continue;
      const key = composeHydraGameKey({
        date: parsed.date, teamA: pair.awayCode, teamB: pair.homeCode,
      });
      if (key) keys.add(key);
    }
    return keys;
  }, [positions, marketVersion]);
}
